{
  "All Invoices": "Alle facturen — {{name}}",
  "View Invoice": "Bekijk factuur",
  "invoices_one": "{{count}} factuur",
  "invoices_other": "{{count}} facturen",
  "You currently don't have any invoices here": "U heeft momenteel geen facturen hier",
  "Back": "Terug"
}
